module.exports = __webpack_public_path__ + "img/kx5200-4.8201c982.png";